import { CodeBlock as BaseCodeBlock } from '@/components/CodeBlock'

interface CodeBlockProps {
  code: string
  language: string
  label?: string
}

export const CodeBlock = ({ code, language, label = '' }: CodeBlockProps) => (
  <BaseCodeBlock code={code} language={language} label={label} />
)
